// extracted by mini-css-extract-plugin
export default {"cont":"CatItem_cont__vRtoF","gele":"CatItem_gele__H9u+n","before":"CatItem_before__TmiI6","clipImg":"CatItem_clipImg__idG64","sign":"CatItem_sign__-SEho"};